"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author xzf0587 <zhaofengxu@microsoft.com>
 */
require("./teamsApp/create");
require("./teamsApp/validate");
require("./teamsApp/validateAppPackage");
require("./teamsApp/validateTestCases");
require("./teamsApp/configure");
require("./teamsApp/copyAppPackageToSPFx");
require("./teamsApp/publishAppPackage");
require("./teamsApp/syncManifest");
require("./aad/create");
require("./aad/update");
require("./arm/deploy");
require("./botAadApp/create");
require("./deploy/azure/azureAppServiceDeployDriver");
require("./deploy/azure/azureFunctionDeployDriver");
require("./deploy/azure/azureStorageDeployDriver");
require("./deploy/azure/azureStorageStaticWebsiteConfigDriver");
require("./deploy/spfx/deployDriver");
require("./deploy/azure/azureStaticWebAppGetDeploymentTokenDriver");
require("./script/dotnetBuildDriver");
require("./script/npmBuildDriver");
require("./script/npxBuildDriver");
require("./script/scriptDriver");
require("./devTool/installDriver");
require("./file/createOrUpdateEnvironmentFile");
require("./file/createOrUpdateJsonFile");
require("./botFramework/createOrUpdateBot");
require("./m365/acquire");
require("./add/addWebPart");
require("./apiKey/create");
require("./apiKey/update");
require("./oauth/create");
require("./oauth/update");
require("./share/shareToOthers");
require("./typeSpec/compile");
//# sourceMappingURL=index.js.map